import { supabase } from './supabase';
import { registerIacrSource } from './sourceHelpers';
import type { SourceAccessDecision, SourceAccessReason } from './sourceAccessDecision';

export * from './sourceAccessDecision';

type SourceAccessRow = {
    source_id?: unknown;
    source_name?: unknown;
    is_active?: unknown;
    allowed?: unknown;
    feature_id?: unknown;
    reason?: unknown;
};

function normalizeDecision(row: SourceAccessRow): SourceAccessDecision | null {
    const sourceId = Number(row.source_id);
    if (!Number.isInteger(sourceId) || typeof row.source_name !== 'string') {
        return null;
    }

    if (row.source_name.toLowerCase() === 'iacr') registerIacrSource(sourceId);
    return {
        sourceId,
        sourceName: row.source_name,
        isActive: row.is_active === true,
        allowed: row.allowed === true,
        featureId: typeof row.feature_id === 'string' ? row.feature_id : null,
        reason: typeof row.reason === 'string'
            ? row.reason as SourceAccessReason
            : 'denied',
    };
}

export async function fetchCurrentUserSourceAccess(
    projectId: string | null = null
): Promise<SourceAccessDecision[]> {
    const args = projectId ? { p_project_id: projectId } : {};
    const { data, error } = await supabase.rpc('get_current_user_source_access', args);
    if (error) {
        throw error;
    }
    return (Array.isArray(data) ? data : [])
        .map(normalizeDecision)
        .filter((row): row is SourceAccessDecision => row !== null);
}
